import AddressFormatter from '@fragaria/address-formatter';
import React from 'react';

import { EmptyFieldValueRenderer } from '@/components/molecules/EmptyFieldValueRenderer';
import { FieldValue } from '@/components/molecules/FieldValue';
import { isBusinessAddress } from '@/types/customer.ext';
import { CompositeField, ValueType } from '@/types/fields';
import { businessAddressToAddressFormatterInput } from '@/utility/businessAddressToAddressFormatterInput';

interface Props {
  readonly value: ValueType;
  readonly field: CompositeField<unknown>;
}
export const CompositeFieldValueRenderer: React.FC<Props> = (props: Props): React.ReactElement => {
  const { value } = props;

  if (isBusinessAddress(value)) {
    return (
      <FieldValue value={AddressFormatter.format(businessAddressToAddressFormatterInput(value))} />
    );
  }

  return <EmptyFieldValueRenderer />;
};
